import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Fade } from "@mui/material";

interface AlertDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  message: string;
  onAgree?: () => void;
}

const AlertDialog = ({
  open,
  onClose,
  title,
  message,
  onAgree,
}: AlertDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          backdropFilter: "blur(5px)",
        },
      }}
      TransitionComponent={Fade}
      transitionDuration={{ enter: 500, exit: 500 }}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            if (onAgree) onAgree();
            onClose();
          }}
        >
          Go back
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
